<template>
  <div id="offers">
    <h1 class="page-title">{{ $t("RequestHistories.title") }}</h1>

    <div class="col-12">
      <filters @offersFiltersChanged="filtersChanged"
               key="offers-history-filters"
               :isManager="isManager"
               :initFilters="filters"
               :isLoading="offerList.loading"
               :exportIsLoading="offerList.exportLoading"
               @exportCSV="exportOffersFile('csv')"
               @exportXLS="exportOffersFile('xls')"></filters>
    </div>


    <div v-if="offerList.total > 0 && !this.isManager">
      <div class="row">
        <div class="col-12">
          <i class="fa fa-lightbulb-o"></i>
          <span class="font-italic guideline">{{ $t("Offers.guideline") }}</span>
        </div>
      </div>
    </div>

    <tab-header v-if="isManager"
                :isManager="isManager"
                :numberByStatus="numberByStatus"
                :tabsList="tabsList"
                :isLoading="offerList.loading"
                @offersTabChanged="tabChanged"></tab-header>
    <offer-list :isManager="isManager"
                :status="status"
                :offers="offerList"
                :currentPage="page"
                :canEditContract="canEditContract"
                :contractTemplates="contractTemplates"
                @offersPageChanged="pageChanged"
                @offersSortChanged="sortChanged"></offer-list>
  </div>
</template>

<script type="text/javascript">
  import offers_mixin from '@/mixin/offers'

  export default {
    mixins: [offers_mixin],
    computed: {
      tabsList: function(){
        return ['expired', 'expired_and_validated', 'cancelled', 'expired_and_not_validated']
      }
    },
    methods: {
      initTab: function(){
        if (this.tabsList.includes(this.status)) {
          this.reloadOffers()
          return;
        } else {
          if (this.isManager) {
            this.tabChanged('expired')
          } else {
            this.tabChanged('expired_and_validated')
          }
        }
      }
    }
  }
</script>

<style type="text/css" scoped>
  .fa-lightbulb-o {
    font-size: 2rem;
  }

  .guideline {
    font-size: 12px;
  }

  .view-history {
    font-size: 0.8rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/offers/RequestHistories.vue